import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import Patients from "../../modules/Patients";
import CustomButtons from "../ui-elements/Buttons/CustomButtons";
import CustomDangerButton from "../ui-elements/Buttons/CustomDangerButton";
import CustomInput from "../ui-elements/input/CustomInput";
import CustomSelect from "../ui-elements/input/CustomSelect";
import * as yup from "yup";
import { Formik } from "formik";
import { useToasts } from "react-toast-notifications";
import Autocomplete from "../../components/Apt/Autocomplete/Autocomplete";
import { useParams } from "react-router";
import { ImCross } from "react-icons/im";
import { DatePicker } from "antd";
import moment from "moment";
import { FaCaretDown } from "react-icons/fa";
// import 'antd/dist/antd.css'; // Import Ant Design styles
import LdcApi from "../../LdcApis";
import { BsFillCloudUploadFill } from "react-icons/bs";
import { Spin } from "antd";
import { use } from "react";
import AutoAppointmentComplete from "../../components/Apt/AutoAppointmentComplete/AutoAppointmentComplete";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Question from "../../modules/Question";
import DoctorAutoComplete from "../../components/Apt/DoctorAutoComplete/DoctorAutoComplete";
dayjs.extend(customParseFormat);
const priorityData = [
  { id: "Routine", name: "Routine" },
  { id: "Urgent", name: "Urgent" },
];

const departmentData = [
  { id: "Dermatology", name: "Dermatology" },
  { id: "Surgery", name: "Surgery" },
];
// const outcome = [
//   { id: 'Scripts', name: 'Scripts' },
//   { id: 'Letters', name: 'Letters' },
//   { id: 'Advice', name: 'Advice' },
//   { id: 'Results', name: 'Results' },
//   { id: 'Complaints', name: 'Complaints' },
// ];

const outcome = [
  { id: "Upheld", name: "Upheld" },
  { id: "NotUpheld", name: "Not Upheld" },
];
const assignedData = [
  {
    id: "1",
    name: "Abdul Kadir",
  },
];

const validationSchema = yup.object().shape({
  // patientName: yup.string().required('Patient Name is required'),
  notes: yup.string().optional("Field is required."),
  priority: yup.string().optional("Field is required."),
  outComes: yup.string().optional("Field is required."),
  department: yup.string().optional("Field To is required."),
  outcome: yup.string().optional("Field is required."),
  assignedTo: yup.string().optional("Field is required."),
  selectDocument: yup.string().optional("Field is required."),
});

function DoctorNotesForm({
  assignedData,
  patientJobDetails,
  setShowPatientForm,
  getComplaintsDetailsPatient,
  getCaegoryListStatus,
  getRoleListStatus,
  patientLoader,
  showPatientForm,
  editJobData,
}) {
  const { id } = useParams();
  useEffect(() => {
    document.title = "Add Notes - LDC";
  }, []);
  console.log("editJobData", editJobData);
  console.log("showPatientForm xxxx", showPatientForm);
  console.log("getComplaintsDetailsPatient", getComplaintsDetailsPatient);
  // let newDatient;

  // if (patientJobDetails !== undefined) {
  //   newDatient = { ...patientJobDetails, patientName: ` ${patientJobDetails?.firstName} ${patientJobDetails?.lastName}` };
  // } else {
  //   newDatient = { patientName: `` };
  // }

  // const [newDatient, setNewDatient] = useState(null);
  // const [smsTemplate, setSmsTemplate] = useState(null);

  const { addToast } = useToasts();
  // const [patientFormData, setPatientFormData] = useState(newDatient);
  const [addJobDisabled, setAddJobDisabled] = useState(false);
  // const [patients, setPatients] = useState([]);
  const [isPatientList, setIsPatientList] = useState(false);
  const [isTreatmentNoteList, setIsTreatmentNoteList] = useState(false);
  const [treatmentName, setTemplateName] = useState("");
  const [patientList, setPatientList] = useState([]);
  const [treatmentNoteList, setTreatmentNoteList] = useState([]);

  const patientFullName = `${patientJobDetails?.firstName} ${patientJobDetails?.lastName}`;
  const [selectedPhotoFile, setSelectedPhotoFile] = useState([]);
  const [uploadPhotoError, setUploadPhotoError] = useState(false);

  const [deuDateError, setDueDateError] = useState(false);
  const photoUploadRef = useRef(null);
  const [patientName, setPatientName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [doctorList, setDoctorList] = useState([]);
  const [isDoctorList, setIsDoctorList] = useState(false);
  const [doctorLoader, setDoctorLoader] = useState(false);
  const [documentTabData, setDocumentTabData] = useState([]);
  const [selectDocument, setSelectDocument] = useState("");
  const [attachmentLoader, setAttachmentLoader] = useState(false);
  const [treatmentListLoader, setTreatmentListLoader] = useState(false);
  const [replyDate, setReplyDate] = useState("");
  const [complaintDate, setComplaintDate] = useState(dayjs());
  const [deadlineDate, setDeadlineDate] = useState(dayjs());
  const [btnDisable, setBtnDisable] = useState(false);
  const [incidentClass, setIncidentClass] = useState(false);
  // const [deadlineDate, setDeadlineDate] = useState(dayjs().add(28, 'day'));
  const [acknowledgementDate, setAcknowledgementDate] = useState("");

  const [incidentDate, setIncidentDate] = useState("");
  const [appointmentDates, setAppointmentDates] = useState([]);
  const [showAutocomplete, setShowAutocomplete] = useState(false);
  const [allTreatmentNotes, setAllTreatmentNotes] = useState([]);
  // const complaintDate = dayjs().startOf('day'); // Set today
  // const deadlineDate = calculateDeadlineDate(complaintDate); // Set deadline date
  useEffect(() => {
    setSmsTemplate({
      patientName: "",
      fullName: patientFullName,
      mobile: "",
      email: "",
      doctorInvolved: "",
      dateOfComplaint: complaintDate
        ? dayjs(complaintDate).format("YYYY-MM-DD")
        : "",
      // acknowledgementDate: acknowledgementDate
      //   ? dayjs(acknowledgementDate).format('YYYY-MM-DD')
      //   : '',
      deadlineDate: deadlineDate
        ? dayjs(deadlineDate).format("YYYY-MM-DD")
        : "",
      acknowledgementDate: null,
      replyDate: null,
    });
  }, [patientJobDetails]);

  // Store the full list separately
  useEffect(() => {
    Question.getQuestionTemplateNotes((response) => {
      setTreatmentListLoader(true);
      if (response?.status === "success") {
        setTreatmentListLoader(false);

        setAllTreatmentNotes(response.data); // Full list
        setTreatmentNoteList(response.data); // Initially show all
      }
    });
  }, []);

  useEffect(() => {
    if (id) {
      id && fetchDocumentsTabData(id);
    }
  }, [id]);

  useEffect(() => {
    if (documentTabData.length > 0) {
    }
  }, [documentTabData]);
  // useEffect(()=>{
  //   Patients.getDoctorListForAddTaskList((response)=>{
  //     if (response?.status === 'success') {
  //       setAssignedData(response.data);
  //     } else {
  //       addToast('Error Occured while Job adding Patient Job.', { appearance: 'error' });
  //     }
  //   })
  // },[])

  function calculateDeadlineDate(startDate, workingDays = 28) {
    let currentDate = dayjs(startDate);
    let addedDays = 0;

    while (addedDays < workingDays) {
      if (currentDate.day() !== 0) {
        // Count only Monday-Saturday (skip Sundays)
        addedDays++;
      }
      currentDate = currentDate.add(1, "day"); // Move to the next day **after** counting
    }

    return currentDate.subtract(1, "day"); // Adjust for the last extra increment
  }

  useEffect(() => {
    setDeadlineDate(calculateDeadlineDate(complaintDate)); // Calculate deadline on mount
  }, [complaintDate]);

  // Example Usage:
  console.log(calculateDeadlineDate("2024-03-22", 28)); // Should return 23rd April 2024

  const today = dayjs().format("YYYY-MM-DD");
  const [smsTemplate, setSmsTemplate] = useState({
    patientId: "",
    // dateOfComplaint: complaintDate
    //   ? dayjs(complaintDate).format('YYYY-MM-DD')
    //   : '',
    dateOfComplaint: complaintDate.format("YYYY-MM-DD"),
    // deadlineDate: deadlineDate.format('YYYY-MM-DD'),
    appointmentId: "",
    complaintToId: "",
    acknowledgementDate: today,
    deadlineDate: deadlineDate.format("YYYY-MM-DD"),
    complaintToType: "D",
    replyDate: today,
    outcome: "",
    notes: "",
  });

  console.log("deadlineDate", deadlineDate.format("YYYY-MM-DD"));
  const formInitialSchema = {
    patientName: `${smsTemplate?.patientName}`,
    priority: "",
    notes: "",
    outComes: "",
    department: "",
    outcome: "",
    assignedTo: "",
    selectDocument: "",
    mobile: `${smsTemplate?.mobile ? smsTemplate?.mobile : ""}`,
    email: `${smsTemplate?.email ? smsTemplate?.email : ""}`,
    doctorInvolved: `${smsTemplate?.doctorName ? smsTemplate?.doctorName : ""}`,
    shortTerm: "",
    description: "",
    treatmentId: 0,
  };
  console.log("patientJobDetails", patientJobDetails);
  console.log("smsTemplate", smsTemplate);
  console.log("formInitialSchema", formInitialSchema);

  const filterTreatmentNotes = (val) => {
    let filtered = allTreatmentNotes.filter((item) =>
      item.templateName.toLowerCase().includes(val.toLowerCase())
    );
    if (filtered.length > 0) {
      setIsTreatmentNoteList(true);
      setTreatmentNoteList(filtered);
    } else {
      setIsTreatmentNoteList(false);
      setTreatmentNoteList([]); // Empty list if no match
    }
  };
  const onSearchPatient = (e) => {
    let val = e.target.value;
    val = val.replace(/^\s/, "");
    setSmsTemplate((smsTemplate) => ({
      ...smsTemplate,
      fullName: val,
    }));
    setDocumentTabData([]);
    setSelectDocument("");
    let tempSuggestion = [];
    if (val.length >= 3) {
      Patients.getExistPatients(val, (response) => {
        if (response?.status === "success") {
          if (response?.data.length > 0) {
            setIsPatientList(true);
            setPatientList(response.data);
          } else {
            setIsPatientList(false);
            setPatientList([]);
          }
        }
      });
    } else {
      setIsPatientList(false);
      setPatientList([]);
    }
  };

  const onDoctorNotesItem = (item, setFieldValue) => {
    console.log("item onDoctorNotesItem-->", item);
    setTemplateName(item.templateName); // Set input value
    setIsTreatmentNoteList(false); // Hide dropdown
    setSmsTemplate((smsTemplate) => ({
      ...smsTemplate,
      fullName: item.templateName, // Update templateName
    }));
    setFieldValue("templateName", item.templateName);
    setFieldValue("treatmentId", item.id);
  };

  const onPatientItem = (item, setFieldValue) => {
    setSmsTemplate({
      ...smsTemplate,
      patientId: item.id,
      patientName: item.fullName,
      fullName: item.fullName,
      // fullName: item.fullName,
      mobile: item.mobile,
      email: item.email,
    });
    // Update Formik fields
    setFieldValue("patientName", item.fullName);
    setFieldValue("mobile", item.mobile);
    setFieldValue("email", item.email);

    // setFieldValue("templateName", item.templateName);
    // setFieldValue("shortTerm", item.templateName);

    fetchDocumentsTabData(item.id);
    setPatientName(item.fullName + ` :: ${item.id}`);
    setIsPatientList(false);
    setPatientList([]);
  };
  const onDoctorItem = (item) => {
    console.log("itemdoc--->", item);
    // setDoctorName(item.firstName);
    setSmsTemplate({
      ...smsTemplate,
      doctorInvolved: item.name,
      // doctorInvolved: `${item.firstName + '' + item.lastName}`,
      complaintToId: item.id, // Update field
      complaintToType: item.type,
    });
    setIsDoctorList(false);
  };

  const onSearchDoctor = (e) => {
    let val = e.target.value.trim(); // Remove leading spaces
    setSmsTemplate({
      ...smsTemplate,
      doctorInvolved: val, // Update field
    });

    let tempSuggestion = [];

    if (val.length >= 3) {
      Patients.getStaffAndUser(val, (response) => {
        console.log("responseStaff", response);
        if (response?.status === "success") {
          if (response?.data?.data?.length > 0) {
            console.log("hit");
            setIsDoctorList(true);
            setDoctorList(response.data?.data); // Store doctors in state
          } else {
            setIsDoctorList(false);
            setDoctorList([]); // No results found
          }
        }
      });
    } else {
      setIsDoctorList(false);
      setDoctorList([]); // Reset list if less than 3 chars
    }
  };

  const fetchDocumentsTabData = (id) => {
    setAttachmentLoader(true);
    LdcApi({
      method: "GET",
      url: `Patients/GetPatientAttachmentsBypatientID?patientId=${id}`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        if (response?.status === 200) {
          setAttachmentLoader(false);
          setDocumentTabData(response?.data);
        }
      })
      .catch((error) => {});
  };
  const fetchAppointmentDates = (patientId) => {
    LdcApi({
      method: "GET",
      url: `Appointment/GetAppointmentDateByPatient?patientId=${patientId}`,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("response", response);
        if (
          response?.data?.status?.isSuccess &&
          response?.data?.data?.length > 0
        ) {
          setAppointmentDates(response.data.data);
          setShowAutocomplete(true);
        } else {
          setShowAutocomplete(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching appointment dates:", error);
        setAppointmentDates([]);
        setShowAutocomplete(false);
      });
  };
  const fetchShortCuts = () => {
    LdcApi({
      method: "GET",
     url: `TreatmentNoteTemplate/GetDoctorNoteShortcut`,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("response", response);
        if (
          response?.data?.status?.isSuccess &&
          response?.data?.data?.length > 0
        ) {
          getComplaintsDetailsPatient(response.data);
          setShowAutocomplete(true);
        } else {
          setShowAutocomplete(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching appointment dates:", error);
        getComplaintsDetailsPatient([]);
        setShowAutocomplete(false);
      });
  };

  const submitComplaint = async (values) => {
    setBtnDisable(true);

    const complaintData = {
      ID: 0,

      ///
      treatmentNoteTemplateID: values.treatmentId,
      shortcuts: values.shortTerm,
      description: values.description,
    };

    console.log("complaintData", complaintData);

    const hasValidationError = Object.values(validationError).some(
      (err) => err === true
    );

    if (hasValidationError) {
      setBtnDisable(false);
      addToast("All Fields are mandatory to fill.", { appearance: "warning" });
    } else {
      try {
        const res = await LdcApi({
          method: "POST",
         url: "TreatmentNoteTemplate/UpsertDoctorNoteShortcut",
          data: complaintData,
        });
        console.log("res", res);
        if (res.data.status.isSuccess === true) {
          addToast("Notes saved successfully.", { appearance: "success" });

          setShowPatientForm(false);
          setPatientName("");
          //  getComplaintsDetailsPatient(res?.data);
          fetchShortCuts();
          // **Clear Local State**
          setSmsTemplate({
            patientId: "",
            dateOfComplaint: "",
            appointmentId: "",
            complaintToId: "",
            acknowledgementDate: "",
            deadlineDate: "",
            replyDate: "",
            outcome: "",
            notes: "",
          });
          // window.location.reload();
          setPatientName("");
          setIncidentDate("");
          setSelectDocument("");
          setDocumentTabData([]);
          setIsPatientList(false);
          setPatientList([]);
        } else {
          addToast(res?.data?.status?.errorMessage, { appearance: "error" });
        }
      } catch (err) {
        console.log("err", err?.response);
         const errorMessage =
    err?.response?.data?.status?.errorMessage || "Shortcut cannot be duplicate";
        addToast( errorMessage, {
          appearance: "error",
        });
      } finally {
        setBtnDisable(false);
      }
    }
  };

  const [validationError, setValidationError] = useState({
    patientName: false,
    notes: false,
    department: false,
    priority: false,
    outcome: false,
    assignedTo: false,
    doctorInvolved: false,

    // selectDocument:false,
  });
  console.log("validationError", validationError);
  const savePatient = () => {
    console.log("save");
  };

  const formatSentenceCase = (text) => {
    return text
      .toLowerCase() // Convert everything to lowercase first
      .replace(/(^\s*\w|[\.\!\?]\s*\w)/g, (match) => match.toUpperCase()); // Capitalize first letter of each sentence
  };
  const handleCutButtonClick = (fileName) => {
    const updatedFiles = selectedPhotoFile.filter(
      (file) => file.name !== fileName
    );
    setSelectedPhotoFile(updatedFiles);
  };
  const handleButtonClick = () => {
    // Programmatically trigger a click event on the hidden file input
    photoUploadRef.current.click();
  };
  const handlePhoto = (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles) {
      setUploadPhotoError(false);
      setSelectedPhotoFile([...selectedPhotoFile, ...newFiles]);
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setIsTreatmentNoteList(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setSmsTemplate((prevTemplate) => ({
      ...prevTemplate,
      dateOfComplaint: complaintDate.format("YYYY-MM-DD"),
      deadlineDate: deadlineDate.format("YYYY-MM-DD"),
    }));
  }, [complaintDate, deadlineDate]); // Trigger update when complaintDate changes

  const handleDateChange = (date) => {
    if (date) {
      setComplaintDate(date); // Store dayjs object
      setDeadlineDate(date.add(28, "day"));
    }
  };

  const handleReplyDate = (date) => {
    if (date) {
      setReplyDate(date);

      setSmsTemplate((prev) => ({
        ...prev,
        replyDate: dayjs(date).format("YYYY-MM-DD"), // Convert to YYYY-MM-DD
      }));
    }
  };

  const handleDeadlineDateChange = (date) => {
    if (date) {
      setDeadlineDate(date);
    }
  };
  // const handleDateChange = (date) => {
  //   if (date) {
  //     // setComplaintDate(date); // Ensure `date` is a valid dayjs object
  //     setSmsTemplate((prev) => ({
  //       ...prev,
  //       dateOfComplaint: date.format('YYYY-MM-DD'),
  //     }));
  //   }
  // };
  const handleDateAcknowledgementChange = (date) => {
    if (date) {
      setAcknowledgementDate(date);
      setSmsTemplate((prev) => ({
        ...prev,
        acknowledgementDate: dayjs(date).format("YYYY-MM-DD"), // Convert to YYYY-MM-DD
      }));
    }
  };

  const handleIncidentDateClick = () => {
    if (!showAutocomplete) {
      fetchAppointmentDates(smsTemplate.patientId); // Fetch only when opening
    }
    setShowAutocomplete((prev) => !prev); // Toggle open/close
  };
  const handleSelectDate = (appointment, setFieldValue) => {
    const formattedDate = dayjs(appointment.appointmentDate).format(
      "DD/MM/YYYY"
    );
    setIncidentDate(formattedDate);
    // setIncidentDate(appointment.appointmentDate.split('T')[0]); // Format date
    setIncidentClass(false);
    setShowAutocomplete(false);
    console.log("appointment--->>", appointment);
    setSmsTemplate((prev) => ({
      ...prev,
      doctorInvolved: appointment.doctorName,
      complaintToId: appointment.doctorId,
      appointmentId: appointment.appointmentId,
      complaintToType: appointment.complaintToType
        ? appointment.complaintToType
        : "D",
    }));
    setFieldValue("incidentDate", appointment.appointmentId);
    setFieldValue("doctorInvolved", appointment.doctorName);
  };
  console.log("showAutocomplete", showAutocomplete);

  return (
    <div>
      {smsTemplate ? (
        <Card className="p-3 mt-2">
          <Formik
            enableReinitialize
            initialValues={formInitialSchema}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              await submitComplaint(values, resetForm);
            }}
          >
            {({
              values,
              errors,
              resetForm,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form id="patientForm" onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <label>
                      Treatment Note <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Group
                      className="mb-3"
                      style={{ position: "relative" }}
                      ref={inputRef}
                    >
                      <input
                        autoComplete="off"
                        type="text"
                        name="treatmentNote"
                        placeholder="Treatment Note"
                        value={treatmentName}
                        onFocus={() => {
                          setIsTreatmentNoteList(true);
                          setTreatmentNoteList(allTreatmentNotes); // Show all on focus
                        }}
                        onChange={(e) => {
                          setTemplateName(e.target.value);
                          filterTreatmentNotes(e.target.value); // Filter as user types
                        }}
                        className="form-control"
                        required
                      />

                      {isTreatmentNoteList && (
                        <div className="firstName-dropdown">
                          <DoctorAutoComplete
                            type={treatmentNoteList}
                            onFsListItem={(item) =>
                              onDoctorNotesItem(item, setFieldValue)
                            }
                          />
                        </div>
                      )}

                      {treatmentListLoader && (
                        <p
                          style={{
                            position: "absolute",
                            top: "6px",
                            right: "20px",
                            marginBottom: "0px",
                          }}
                        >
                          <Spin />
                        </p>
                      )}
                      {validationError.patientName && (
                        <small className="text-danger error_field">
                          Field is required.
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <label>
                      Shortcut <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Group className="mb-3">
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        name="shortTerm"
                        className="form-control"
                        placeholder="Short Term"
                        value={values.shortTerm}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isInvalid={!!errors.shortTerm && touched.shortTerm}
                        style={{ borderColor: errors.shortTerm ? "red" : "" }}
                        required
                      />
                      {errors.shortTerm && touched.shortTerm && (
                        <Form.Control.Feedback type="invalid">
                          {errors.shortTerm}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <label>
                      Description <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Group className="mb-3">
                      <textarea
                        autoComplete="off"
                        cols="60"
                        rows="1"
                        style={{ borderColor: errors.description ? "red" : "" }}
                        name="description"
                        className="form-control"
                        placeholder="Description"
                        value={values.description}
                        onBlur={handleBlur}
                        error={errors.description}
                        touched={touched.description}
                        required
                        // onChange={(e) => {
                        //   const transformedValue = e.target.value.replace(
                        //     /(^\s*\w|[\.\!\?]\s*\w)/g,
                        //     (match) => match.toUpperCase()
                        //   );

                        //   handleChange({
                        //     target: {
                        //       name: e.target.name,
                        //       value: transformedValue,
                        //     },
                        //   });

                        //   // Also update smsTemplate with transformed text
                        //   setSmsTemplate({
                        //     ...smsTemplate,
                        //     notes: transformedValue,
                        //   });
                        // }}
                        onChange={(e) => {
                          handleChange(e); // Update form state
                          // setSmsTemplate({
                          //   ...smsTemplate,
                          //   notes: e.target.value, // Update smsTemplate
                          // });
                        }}
                        ////style={{ width: '100%', marginTop: '-10px' }}
                      />
                      {/* {validationError.description && (
                        <small className="text-danger error_field">
                          Field is required.
                        </small>
                      )} */}
                    </Form.Group>
                  </Col>
                </Row>
                <div className="my-4 mb-3 p-2 d-flex">
                  <CustomButtons
                    buttonDisabled={addJobDisabled}
                    type="submit"
                    variant="primary"
                    name={btnDisable ? "Loading..." : "Save"}
                  />
                  <CustomDangerButton
                    cancelOnClick={() => setShowPatientForm(false)}
                    variant="danger"
                    name="Cancel"
                  />
                </div>
              </Form>
            )}
          </Formik>
        </Card>
      ) : (
        <p>loading...</p>
      )}
    </div>
  );
}

export default DoctorNotesForm;
